/* eslint @stylistic/key-spacing: ["error", {  "align": "value" }]*/

const ROUTES = {
    HOME:                     'home',
    USERS:                    'users',
    TICKETHOLDER:             'ticket-holder-page',
    SCHOOL_ASSIGNMENT_CHANGE: 'school-assignment-change-page',
    PRODUCT:                  'product-page',
    TICKETCREATION:           'ticket-creation',
    ACCOUNTING:               'accounting',
    SCHOOL_AND_CLASSES:       'school-and-classes',
    APPLICATIONS:             'applications'
}

export default ROUTES